import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export function initGallerySlider() {
    const sliderElement = document.querySelector('.js-gallery-slider');
    
    if (!sliderElement) return;

    let swiperInstance = null;

    function initSwiper() {
        if (window.innerWidth < 768 && !swiperInstance) {
            swiperInstance = new Swiper(sliderElement, {
                modules: [Navigation, Pagination],
                slidesPerView: 1.2,
                spaceBetween: 13,
                slidesOffsetAfter: 24,
                loop: false,
                pagination: {
                    el: '.swiper-galleryblock-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.c_swiper-galleryblock-next',
                    prevEl: '.c_swiper-galleryblock-prev',
                },
            });
        } else if (window.innerWidth >= 768 && swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    }

    initSwiper();
    window.addEventListener('resize', initSwiper);
}
